/* tslint:disable */
/* eslint-disable */
/**
 * Leads API
 * API for managing leads (potential customers from external sources)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Erreur métier de conversion (HTTP 200, success=false)
 * @export
 * @interface MaterialiserLeadErrorDto
 */
export interface MaterialiserLeadErrorDto {
    /**
     * 
     * @type {string}
     * @memberof MaterialiserLeadErrorDto
     */
    code?: string | null;
    /**
     * Message prêt à afficher
     * @type {string}
     * @memberof MaterialiserLeadErrorDto
     */
    message?: string | null;
}

/**
 * Check if a given object implements the MaterialiserLeadErrorDto interface.
 */
export function instanceOfMaterialiserLeadErrorDto(value: object): value is MaterialiserLeadErrorDto {
    return true;
}

export function MaterialiserLeadErrorDtoFromJSON(json: any): MaterialiserLeadErrorDto {
    return MaterialiserLeadErrorDtoFromJSONTyped(json, false);
}

export function MaterialiserLeadErrorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaterialiserLeadErrorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function MaterialiserLeadErrorDtoToJSON(json: any): MaterialiserLeadErrorDto {
    return MaterialiserLeadErrorDtoToJSONTyped(json, false);
}

export function MaterialiserLeadErrorDtoToJSONTyped(value?: MaterialiserLeadErrorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
    };
}

